import { MODE_ANALYTICS, ModeAnalytics } from '@/constants/analytics'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

const PLATFORM_MODE = {
  gen2Yeti: MODE_ANALYTICS.YETI_STANDARD,
  gen2: MODE_ANALYTICS.GEN2,
  gen1: MODE_ANALYTICS.GEN1,
} as const

type PlatformScreenMode =
  | ModeAnalytics['YETI_STANDARD']
  | ModeAnalytics['GEN2']
  | ModeAnalytics['GEN1']
  | undefined

export const getPlatformScreenMode = (): PlatformScreenMode => {
  const platform =
    getCommonsNorthboundAPIs().v1?.store.state.onboarding.sessionContext
      .derivedAttributes?.pls?.platformIdentifier
  return platform ? PLATFORM_MODE[platform] : undefined
}
